<template>
  <el-container class="body_container">
    <el-header style="height: 50px;padding:0px">
      <el-row type="flex" class="body_title">
        <el-col>周期设置</el-col>
      </el-row>
    </el-header>
    <el-main class="search_result">
      <el-row style="height: 50px"></el-row>
      <el-form :model="numberValidateForm" ref="numberValidateForm" label-width="200px" class="readonly demo-ruleForm" id="dvInput" style="width: 350px;margin: 0 auto">
        <el-form-item label=" 该日期是年度学分时间节点，为月日格式，如：11.08" label-width="350px">
          <!--该日期是年度学分时间节点，为月日格式。-->
        </el-form-item>
        <el-form-item label="正式律师课时日期区间" prop="age" :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="numberValidateForm.age" style="width: 200px" placeholder="格式：11.08"></el-input>
        </el-form-item>
        <el-form-item label="实习律师课时日期区间" prop="age" :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="numberValidateForm.ages" style="width: 200px" placeholder="格式：11.08"></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 40px">
          <el-button @click="bianji()" style="background-color: rgb(255, 255, 255);border: 1px solid rgb(62, 100, 255);color: rgb(62, 100, 255);padding: 7px 12px;">编辑</el-button>
          <el-button type="primary" @click="submitForm('numberValidateForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import period from '@/api/period'
export default {
  name: 'CycleSet',
  data() {
    return {
      numberValidateForm: {
        id: null,
        age: '',
        ages: ''
      },
      searchVo: {
        keyword: '',//用户名/姓名/角色
        page: 1,
        rows: 10
      },
      userDialog: false,
      user: {
        id: '',
        realName: ''
      }
    }
  },
  methods: {
    reload() {
      period.findTimeNode().then(res => {
        // console.log(res.data.data[0])
        this.numberValidateForm.id = res.data.data[0].id
        this.numberValidateForm.age = res.data.data[0].month + '.' + res.data.data[0].day
        this.numberValidateForm.ages = res.data.data[0].months + '.' + res.data.data[0].days
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this.numberValidateForm.age)
          // console.log(this.numberValidateForm.ages)
          let zhengshiList = this.numberValidateForm.age.split('.')
          let shixiList = this.numberValidateForm.ages.split('.')
          let obj = {
            month: zhengshiList[0],
            day: zhengshiList[1],
            months: shixiList[0],
            days: shixiList[1],
          }
          // console.log(obj)
          period.addTimeNode(obj).then(res => {
            this.$message.info(res.data.message)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      // var id = document.getElementById('dvInput')
      // id.classList.add('readonly')
    },
    // 编辑
    bianji () {
      var id = document.getElementById('dvInput')
      id.classList.remove('readonly')
    }
  },
  created() {
    this.reload()
  }
}
</script>
<style>
  .readonly input{
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/system/CycleSet.vue